import React, {PropTypes as T} from 'react';

const SIMSvgLabel = (props) => {

  var attributes = {
    'data-component': 'svg__label',
    'data-label-id': props.sectionId,
    className:        'svg__label',
    transform:        '',
    fontSize:         props.fontSize
  };

  if (props.angle) {
    attributes.transform += `rotate(${props.angle * -1},${props.rotationPosition.x},${props.rotationPosition.y})`;
  }

  var textSpans = props.text.map(function (text, idx) {
    return (
      <tspan
        key={idx}
        dy={`${(idx + 1) * 1.1}em`}
        {...props.position}
        style={{fontWeight: props.fontWeight }}>
        {text || '\u00a0'}
      </tspan>
    );
  });

  attributes.className += props.showSeats ? ' showseats' : '';

  return (
    <text {...attributes}>
      {textSpans}
    </text>
  );
};

SIMSvgLabel.propTypes = {
  id:               T.string,
  sectionId:        T.string,
  showSeats:        T.bool,
  position:         T.shape({x: T.number.isRequired, y: T.number.isRequired}).isRequired,
  rotationPosition: T.shape({x: T.number.isRequired, y: T.number.isRequired}).isRequired,
  angle:            T.number.isRequired,
  fontSize:         T.number.isRequired,
  fontWeight:       T.string,
  text:             T.arrayOf(T.string).isRequired
};

export default SIMSvgLabel;



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/svg/label.jsx